import moment from 'moment-timezone'
import React from 'react'
import RecurrenceAmountAndFrequencyLabel from 'src/components/RecurrenceAmountAndFrequencyLabel/RecurrenceAmountAndFrequencyLabel'
import RecurrenceEndingLabel from 'src/components/RecurrenceEndingLabel/RecurrenceEndingLabel'
import { ExtendCurrency } from 'src/enums'
import Trns from 'src/localization/Trns'
import {
  RecurrenceModel,
  RecurrenceTerminator,
} from 'src/models/recurrence.models'

interface VirtualCardRevisionsFrequencyProps {
  className?: string
  recurrence: RecurrenceModel
  timezone: string
  balance: number
  currency?: ExtendCurrency
}

const VirtualCardRevisionsFrequency: React.FC<
  VirtualCardRevisionsFrequencyProps
> = (props): React.ReactElement => {
  return (
    <Trns
      source={
        props.recurrence.terminator === RecurrenceTerminator.Count
          ? '${recurrenceAmountAndFrequencyLabel}. ${recurrenceEndingLabel}.'
          : '${recurrenceAmountAndFrequencyLabel}, ${recurrenceEndingLabel}.'
      }
      expressions={{
        recurrenceAmountAndFrequencyLabel: (
          <RecurrenceAmountAndFrequencyLabel
            period={props.recurrence.period}
            balance={props?.balance}
            interval={props.recurrence.interval}
            byWeekDay={props.recurrence.byWeekDay}
            byMonthDay={props.recurrence.byMonthDay}
            byYearDay={props.recurrence.byYearDay}
            timezone={props.timezone}
            currency={props.currency || ExtendCurrency.Usd}
          />
        ),
        recurrenceEndingLabel: (
          <RecurrenceEndingLabel
            terminator={props.recurrence.terminator}
            count={props.recurrence?.remainingCount || 0}
            untilMoment={moment(
              props.recurrence.untilTimezonedMoment(props.timezone),
            )}
          />
        ),
      }}
    />
  )
}

export default VirtualCardRevisionsFrequency
